import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';

import firebase from 'firebase/compat/app';
import OneSignal from 'onesignal-cordova-plugin';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private fireAuth: AngularFireAuth,
    private firestore: AngularFirestore,
    private router: Router
  ) {}

  registerUser(details) {
    const { accountType, name, surname, phone, email, password } = details;
    return this.fireAuth
      .createUserWithEmailAndPassword(email, password)
      .then((response) => {
        const uid = response.user.uid;
        const time = firebase.firestore.FieldValue.serverTimestamp();
        return this.firestore
          .collection('Users')
          .doc(uid)
          .set({
            accountType,
            name,
            surname,
            phone,
            email,
            userID: uid,
            createdAt: time,
          })
          .then(() => {
            this.firestore.collection('AllUsers').doc(uid).set({
              userID: uid,
              role: accountType,
              email,
              phone,
            });
          })
          .then(() => {
            this.firestore.collection(`Users/${uid}/Wallet`).doc('wallet').set({
              rands: 0,
            });
          });
      });
  }

  registerStore(details) {
    const { accountType, name, surname, phone, email, password } = details;
    return this.fireAuth
      .createUserWithEmailAndPassword(email, password)
      .then((response) => {
        const uid = response.user.uid;
        const time = firebase.firestore.FieldValue.serverTimestamp();
        return this.firestore
          .collection('Stores')
          .doc(uid)
          .set({
            accountType,
            name,
            surname,
            phone,
            email,
            userID: uid,
            createdAt: time,
          })
          .then(() => {
            this.firestore.collection('AllUsers').doc(uid).set({
              userID: uid,
              role: accountType,
              email,
              phone,
            });
          });
      });
  }

  registerDriver(details) {
    const { accountType, name, surname, phone, email, password } = details;
    return this.fireAuth
      .createUserWithEmailAndPassword(email, password)
      .then((response) => {
        const uid = response.user.uid;
        const time = firebase.firestore.FieldValue.serverTimestamp();
        return this.firestore
          .collection('Drivers')
          .doc(uid)
          .set({
            accountType,
            name,
            surname,
            phone,
            email,
            userID: uid,
            createdAt: time,
          })
          .then(() => {
            this.firestore.collection('AllUsers').doc(uid).set({
              userID: uid,
              role: accountType,
              email,
              phone,
            });
          });
      });
  }

  login(email, password) {
    return this.fireAuth.signInWithEmailAndPassword(email, password);
  }

  checkUser(collection, email) {
    email = email.toLowerCase();
    return this.firestore
      .collection(collection, (ref) => ref.where('email', '==', email))
      .get();
  }

  checkPhone(phone) {
    return this.firestore
      .collection('AllUsers', (ref) => ref.where('phone', '==', phone))
      .get();
  }

  verifyID(userID) {
    return this.firestore.collection('AllUsers').doc(userID).get();
  }

  resetPassword(email) {
    return this.fireAuth.sendPasswordResetEmail(email);
  }

  logout() {
    return this.fireAuth.signOut().then(() => {
      this.router.navigate(['/home/login']);
    });
  }

  setDriverPlayerID(userID, playerID) {
    return this.firestore.collection('AllUsers').doc(userID).update({
      playerID,
    });
  }

  getDriversPlayerIDs() {
    return this.firestore
      .collection('AllUsers', (ref) => ref.where('role', '==', 'Driver'))
      .get();
  }

  getDriverPlayerID(driverID) {
    return this.firestore.collection('AllUsers').doc(driverID).get();
  }

  getStores() {
    return this.firestore.collection('Stores').snapshotChanges();
  }

  setStorePlayerID(userID, playerID) {
    return this.firestore.collection('Stores').doc(userID).update({
      playerID,
    });
  }

  setAgentPlayerID(userID, playerID) {
    return this.firestore.collection('CallAgents').doc(userID).update({
      playerID,
    });
  }

  getAgentsPlayerIDs() {
    return this.firestore.collection('CallAgents').get();
  }
}
